var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { useSegmentedControlContext } from "./QuiSegmentedControlContext.js";
import classNames from "classnames";
import { WithIcon, fieldSizeToIconSize } from "../_primitives/WithIcon.js";
export function QuiSegmentedControlButton(_a) {
    var { value, iconLeft, disabled: selfDisabled, iconRight, children, className } = _a, otherProps = __rest(_a, ["value", "iconLeft", "disabled", "iconRight", "children", "className"]);
    const { onChange, selectedValue, size, disabled } = useSegmentedControlContext();
    const selected = value === selectedValue;
    const iconProps = { iconLeft, iconRight, iconSize: fieldSizeToIconSize(size) };
    const cn = classNames([
        "qui-interactive",
        "qui-segmented-control__button",
        {
            "qui-segmented-control__button--selected": selected,
            "qui-segmented-control__button--alldisabled": disabled, // only set if all buttons are disabled, needed for border-fix stuff
        },
        className,
    ]);
    return (React.createElement("button", Object.assign({ type: "button", "aria-current": value === selectedValue, onClick: () => onChange(value), className: cn }, otherProps, { disabled: disabled || selfDisabled }),
        React.createElement(WithIcon, Object.assign({}, iconProps), children),
        React.createElement("span", { className: "qui-segmented-control__button__border-fix" })));
}
